{
  "interface": "Interface",
  "newInterface": "New interface",
  "updateInterface": "Update interface",
  "generateNewInterface": "Generate new interface",
  "tabs": {
    "mobileApp": {
      "title": "Mobile application",
      "column": {
        "organizationName": "Organization name",
        "name": "Interface name",
        "deviceTypes": "Device type",
        "updatedAt": "Updated at"
      },
      "form": {
        "information": {
          "title": "Information",
          "organizationName": "Organization name",
          "name": "Name",
          "description": "Description"
        },
        "deviceTypes": {
          "title": "Properties of equipment lines",
          "label": "Types",
          "add": "Add",
          "save": "Save",
          "cancel": "Cancel",
          "noLabel": "Unknown type"
        },
        "validation": {
          "name": "The interface name is mandatory",
          "nameFormat": "The interface name can only contain alphanumeric characters or underscores",
          "uniqueName": "Interface name must be unique"
        }
      },
      "empty": "No mobile applications available"
    },
    "thirdPartyApp": {
      "title": "Third-party application",
      "column": {
        "organizationName": "Organization name",
        "interfaceName": "Interface name",
        "authMethod": "Authentication method",
        "profile": "Profile",
        "updatedAt": "Updated at",
        "status": "Status"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "authMethod": {
        "clientGrant": "Client Grant",
        "mtls": "mTLS",
        "userCredentials": "Client credentials"
      },
      "form": {
        "title": "Information",
        "organizationName": "Organization name",
        "name": "Interface name",
        "profile": {
          "label": "Profile",
          "placeholder": "Select 1 profile"
        },
        "sectors": {
          "label": "Sectors",
          "placeholder": "Select sectors"
        },
        "authenticationType": {
          "label": "Authentication type",
          "clientGrant": "ClientGrant",
          "mtls": "mTLS"
        },
        "validation": {
          "organizationName": "Organization name is mandatory",
          "name": "The name is mandatory",
          "profile": "Profile is mandatory",
          "sectors": "Selection of one or more sectors is mandatory",
          "authenticationType": "Authentication type is mandatory",
          "nameFormat": "The interface name can only contain alphanumeric characters or underscores",
          "uniqueName": "Interface name must be unique"
        },
        "update": {
          "sidePanelTitle": "Modification of the third-party interface",
          "information": {
            "title": "Important",
            "content": "If you lost your client secret, please delete this interface, and create a new one"
          }
        },
        "confirmCancelUpdate": {
          "title": "Cancel interface update",
          "message": "Are you sure you want to cancel the interface update?"
        },
        "confirmCancelCreate": {
          "title": "Cancel interface  creation",
          "message": "Are you sure you want to cancel the creation of the interface?"
        }
      },
      "creationModalSuccess": {
        "header": {
          "title": "Success",
          "info": "Warning: Keep these informations, they will not be available anymore once this page is closed."
        },
        "clientId": {
          "label": "ClientId"
        },
        "secret": {
          "label": "Secret"
        },
        "copyToClipboard": {
          "copied": "Copied",
          "buttonTitle": "copy to clipboard"
        }
      },
      "empty": "No third-party applications available",
      "licenseMessage": {
        "disableNewInterface": "The limit of your license has been reached, the interface creation is disabled.",
        "disableActivateInterface": "The limit of your license has been reached, the interface activation is disabled."
      }
    }
  },
  "action": {
    "delete": {
      "confirm": {
        "title": "Delete interface",
        "message": "Interface {name} will be deleted."
      }
    },
    "deactivate": {
      "confirm": {
        "title": "Deactivate interface",
        "message": "Interface {name} will be deactivated."
      }
    },
    "activate": {
      "confirm": {
        "title": "Activate interface",
        "message": "Interface {name} will be activated."
      }
    }
  }
}
